import React, { Component } from "react";
import { PageHeader, Spin, Row, Col, message } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ButtonItem,
  SwitchItem,
  ErrorItem,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import { getDefaultCamposObligatorios } from "../camposClientesConfig";

const SwitchBox = ({
  checked,
  onChange,
  disabled = false,
  checkedChildren = "Sí",
  unCheckedChildren = "No",
}) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      height: 32,
      padding: "0 11px",
      border: `1px solid ${disabled ? "#d9d9d9" : checked ? "#1890ff" : "#d9d9d9"}`,
      borderRadius: 6,
      backgroundColor: disabled ? "#f5f5f5" : checked ? "#e6f7ff" : "#fff",
      width: "100%",
      transition: "background-color 0.3s, border-color 0.3s",
    }}
  >
    <SwitchItem
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      checkedChildren={checkedChildren}
      unCheckedChildren={unCheckedChildren}
    />
  </div>
);

// Wrapper amarillo para campos tipo checkbox
const CheckboxField = ({ children }) => (
  <div style={{ borderLeft: "3px solid #faad14", paddingLeft: 8 }}>
    {children}
  </div>
);

class ConfiguracionClientes extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    formValues: {},
  };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  atras() {
    this.props.history.goBack();
  }

  async consultarConfiguracion() {
    this.setState({ loading: true });
    await axios
      .post(
        "empresas/selectConfiguracionClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const defaults = getDefaultCamposObligatorios();
          const saved = res.data.configuracion?.camposObligatorios || {};
          const valores = { ...defaults, ...saved };
          this.formRef.current.setFieldsValue(valores);
          this.setState({ formValues: valores });
        } else {
          message.error("Error al cargar la configuración de clientes");
        }
      })
      .catch(() => {
        message.error("Error al cargar la configuración de clientes");
      });
    this.setState({ loading: false });
  }

  onFinishFailed = (errorInfo) => {
    ErrorItem(errorInfo);
  };

  onFinish = (values) => {
    this.setState({ loading: true });
    axios
      .post(
        "empresas/editarConfiguracionClientes",
        { camposObligatorios: values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Configuración de clientes guardada");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.warning(
            res.data.message || "No se pudo guardar la configuración"
          );
        } else {
          message.error("Hubo un error al guardar la configuración");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error al guardar la configuración");
      });
  };

  render() {
    const { formValues } = this.state;

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Configuración de Clientes"
          subTitle="Define qué campos son obligatorios al registrar o editar un cliente"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="configuracionClientes"
              layout
              onFinish={this.onFinish}
              onFinishFailed={this.onFinishFailed}
              onValuesChange={(_, allValues) =>
                this.setState({ formValues: allValues })
              }
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  cyan
                  style={{
                    display: "block",
                    margin: "0 0 0 auto",
                    minWidth: 160,
                    height: 30,
                  }}
                >
                  Guardar Configuración
                </ButtonItem>
              }
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 8,
                  background: "#fffbe6",
                  border: "1px solid #ffe58f",
                  borderLeft: "4px solid #faad14",
                  borderRadius: 6,
                  padding: "8px 12px",
                  marginBottom: 16,
                  fontSize: 12,
                  color: "#614700",
                  lineHeight: 1.6,
                }}
              >
                <span style={{ fontSize: 16, lineHeight: 1.4 }}>⚠</span>
                <span>
                  Los campos marcados con{" "}
                  <span
                    style={{
                      display: "inline-block",
                      width: 10,
                      height: 14,
                      borderLeft: "3px solid #faad14",
                      verticalAlign: "middle",
                      marginRight: 2,
                      marginLeft: 2,
                    }}
                  />{" "}
                  (<strong>Leyenda</strong>, <strong>Cliente de Portal</strong>,{" "}
                  <strong>Impresión Especial</strong>) son <strong>casillas de activación</strong>.
                  Si los marcas como obligatorios, el usuario <strong>deberá activarlos</strong> al guardar el cliente.
                </span>
              </div>

              <Row gutter={16}>

                <Col xs={24} lg={13}>

                  <DynamicCardForm title={<span>Datos Generales</span>}>

                    <Row>
                      <Col span={12}>
                        <FormItem
                          label="RFC"
                          margin
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <SwitchBox disabled checked />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          name="clave"
                          label="Clave"
                          margin
                          required={!!formValues.clave}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <SwitchBox />
                        </FormItem>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={12}>
                        <FormItem
                          label="P. Moral"
                          margin
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <SwitchBox disabled />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          name="curp"
                          label="CURP"
                          margin
                          required={!!formValues.curp}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <SwitchBox />
                        </FormItem>
                      </Col>
                    </Row>

                    <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                      <FormItem
                        label="Razón Social"
                        margin
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 21 }}
                      >
                        <SwitchBox disabled checked />
                      </FormItem>
                    </Col>

                    <Row>
                      <Col span={10} xs={24} sm={24} lg={9} xl={9}>
                        <FormItem
                          label="Nombre"
                          margin
                          labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 3 } }}
                          wrapperCol={{ lg: { span: 16 }, xl: { span: 16 }, xs: { span: 21 } }}
                        >
                          <SwitchBox disabled checked />
                        </FormItem>
                      </Col>
                      <Col span={7} xs={24} sm={24} lg={7} xl={7}>
                        <FormItem
                          name="apellidoPaterno"
                          margin
                          required={!!formValues.apellidoPaterno}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ lg: { span: 0 }, xl: { span: 0 }, xs: { span: 20 } }}
                          wrapperCol={{ span: 24 }}
                        >
                          <SwitchBox checkedChildren="Ap. Pat." unCheckedChildren="Ap. Pat." />
                        </FormItem>
                      </Col>
                      <Col span={7} xs={24} sm={24} lg={7} xl={7}>
                        <FormItem
                          name="apellidoMaterno"
                          margin
                          required={!!formValues.apellidoMaterno}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 0 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <SwitchBox checkedChildren="Ap. Mat." unCheckedChildren="Ap. Mat." />
                        </FormItem>
                      </Col>
                    </Row>

                    <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                      <FormItem
                        name="nombreComercial"
                        label={<span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "inline-block", lineHeight: 1.2 }}>Nombre Comercial</span>}
                        margin
                        required={!!formValues.nombreComercial}
                        valuePropName="checked"
                        initialValue={false}
                        labelCol={{ span: 3 }}
                        wrapperCol={{ span: 21 }}
                      >
                        <SwitchBox />
                      </FormItem>
                    </Col>

                  </DynamicCardForm>

                  <DynamicCardForm title="Contacto General" style={{ marginTop: 16 }}>

                    <Row>
                      <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                        <FormItem
                          name="celular"
                          label="Celular"
                          margin
                          required={!!formValues.celular}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 4 } }}
                          wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                          tooltip="Número de celular del cliente."
                        >
                          <SwitchBox />
                        </FormItem>
                        <FormItem
                          name="telefono"
                          label="Teléfono"
                          margin
                          required={!!formValues.telefono}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 4 } }}
                          wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                          tooltip="Número de teléfono fijo del cliente."
                        >
                          <SwitchBox />
                        </FormItem>
                      </Col>
                      <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                        <FormItem
                          name="paginaWeb"
                          label="Página Web"
                          margin
                          required={!!formValues.paginaWeb}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 4 } }}
                          wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                          tooltip="Sitio web del cliente."
                        >
                          <SwitchBox />
                        </FormItem>
                        <FormItem
                          name="correo"
                          label="Correo"
                          margin
                          required={!!formValues.correo}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 4 } }}
                          wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                          tooltip="Correo electrónico principal del cliente. Se usa para envío de documentos."
                        >
                          <SwitchBox />
                        </FormItem>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={24}>
                        <FormItem
                          name="observaciones"
                          label="Observaciones"
                          margin
                          required={!!formValues.observaciones}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 4 }}
                          wrapperCol={{ span: 18 }}
                          tooltip="Notas internas sobre el cliente. No se imprimen en documentos."
                        >
                          <SwitchBox />
                        </FormItem>
                      </Col>
                    </Row>

                    <CheckboxField>
                      <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                        <FormItem
                          name="impresionEspecial"
                          label={<span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "inline-block", lineHeight: 1.2 }}>Impresión Especial</span>}
                          margin
                          required={!!formValues.impresionEspecial}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 4 }}
                          wrapperCol={{ span: 18 }}
                          tooltip="Al activarse, los documentos del cliente se imprimen con un formato especial."
                        >
                          <SwitchBox />
                        </FormItem>
                      </Col>
                    </CheckboxField>

                    <FormItem
                      name="codigoProveedor"
                      label="Código Proveedor"
                      margin
                      required={!!formValues.codigoProveedor}
                      valuePropName="checked"
                      initialValue={false}
                      labelCol={{ span: 5 }}
                      wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 17 } }}
                      tooltip="Código de proveedor para integraciones con sistemas externos (ej. adenda Viscofan)."
                    >
                      <SwitchBox />
                    </FormItem>

                  </DynamicCardForm>

                </Col>

                <Col xs={24} lg={11}>
                  <DynamicCardForm title="Datos Venta">

                    <FormItem
                      label="Tipo Cliente"
                      margin
                      labelCol={{ span: 7 }}
                      wrapperCol={{ span: 16 }}
                      tooltip="Clasificación del cliente. Campo siempre obligatorio."
                    >
                      <SwitchBox disabled checked />
                    </FormItem>

                    <FormItem
                      name="regimenFiscalId"
                      label="R. Fiscal"
                      margin
                      required={!!formValues.regimenFiscalId}
                      valuePropName="checked"
                      initialValue={false}
                      tooltip={{ title: "Campo necesario para facturación." }}
                      labelCol={{ span: 7 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <SwitchBox />
                    </FormItem>

                    <FormItem
                      name="usoDeCFDIID"
                      label="Uso de CFDI"
                      margin
                      required={!!formValues.usoDeCFDIID}
                      valuePropName="checked"
                      initialValue={false}
                      tooltip="Uso que el cliente dará al comprobante fiscal (G03, P01, etc.)."
                      labelCol={{ span: 7 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <SwitchBox />
                    </FormItem>

                    <FormItem
                      name="proyectoId"
                      label="Proyecto"
                      margin
                      required={!!formValues.proyectoId}
                      valuePropName="checked"
                      initialValue={false}
                      tooltip="Proyecto al que se asociarán las operaciones del cliente por defecto."
                      labelCol={{ span: 7 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <SwitchBox />
                    </FormItem>

                    <FormItem
                      name="vendedorId"
                      label="Vendedor"
                      margin
                      required={!!formValues.vendedorId}
                      valuePropName="checked"
                      initialValue={false}
                      tooltip="Vendedor asignado al cliente para comisiones y reportes."
                      labelCol={{ span: 7 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <SwitchBox />
                    </FormItem>

                    <FormItem
                      name="bancoId"
                      label="Banco"
                      margin
                      required={!!formValues.bancoId}
                      valuePropName="checked"
                      initialValue={false}
                      tooltip="Banco de la cuenta del cliente para aplicación de cobros."
                      labelCol={{ span: 7 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <SwitchBox />
                    </FormItem>

                    <FormItem
                      name="formaDePagoId"
                      label="Forma de Pago"
                      margin
                      required={!!formValues.formaDePagoId}
                      valuePropName="checked"
                      initialValue={false}
                      tooltip="Forma de pago predeterminada para el cliente."
                      labelCol={{ span: 7 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <SwitchBox />
                    </FormItem>

                    <FormItem
                      name="monedaId"
                      label="Moneda"
                      margin
                      required={!!formValues.monedaId}
                      valuePropName="checked"
                      initialValue={false}
                      tooltip="Moneda predeterminada para el cliente."
                      labelCol={{ span: 7 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <SwitchBox />
                    </FormItem>

                    <Row gutter={[8, 0]}>
                      <Col span={12}>
                        <FormItem
                          name="diasCredito"
                          label="Días crédito"
                          margin
                          required={!!formValues.diasCredito}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 14 }}
                          wrapperCol={{ span: 10 }}
                          tooltip="Días de plazo para que el cliente pague sus facturas."
                        >
                          <SwitchBox />
                        </FormItem>
                        <FormItem
                          name="limiteCredito"
                          label="Crédito"
                          margin
                          required={!!formValues.limiteCredito}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 14 }}
                          wrapperCol={{ span: 10 }}
                          tooltip="Monto máximo de crédito autorizado al cliente."
                        >
                          <SwitchBox />
                        </FormItem>
                        <FormItem
                          name="limiteDescuento"
                          label="Desc Máx. %"
                          margin
                          required={!!formValues.limiteDescuento}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 14 }}
                          wrapperCol={{ span: 10 }}
                          tooltip="Porcentaje máximo de descuento aplicable al cliente."
                        >
                          <SwitchBox />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          name="precioContadoId"
                          label="P. Contado"
                          margin
                          required={!!formValues.precioContadoId}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 9 }}
                          wrapperCol={{ span: 13 }}
                          tooltip="Lista de precios para ventas de contado."
                        >
                          <SwitchBox />
                        </FormItem>
                        <FormItem
                          name="precioCreditoId"
                          label="P. Crédito"
                          margin
                          required={!!formValues.precioCreditoId}
                          valuePropName="checked"
                          initialValue={false}
                          labelCol={{ span: 9 }}
                          wrapperCol={{ span: 13 }}
                          tooltip="Lista de precios para ventas a crédito."
                        >
                          <SwitchBox />
                        </FormItem>
                      </Col>
                    </Row>

                    <CheckboxField>
                      <FormItem
                        name="leyenda"
                        label="Leyenda"
                        margin
                        required={!!formValues.leyenda}
                        valuePropName="checked"
                        initialValue={false}
                        labelCol={{ span: 7 }}
                        wrapperCol={{ span: 16 }}
                        tooltip="Al activarse, se imprime una leyenda especial en los documentos del cliente."
                      >
                        <SwitchBox />
                      </FormItem>
                      <FormItem
                        name="clienteDePortal"
                        label={<span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "inline-block", lineHeight: 1.2 }}>Cliente de Portal</span>}
                        margin
                        required={!!formValues.clienteDePortal}
                        valuePropName="checked"
                        initialValue={false}
                        tooltip='Al activarse, el cliente estará disponible en "Portal Clientes" para seguimiento de sus facturas.'
                        labelCol={{ span: 7 }}
                        wrapperCol={{ span: 16 }}
                      >
                        <SwitchBox />
                      </FormItem>
                    </CheckboxField>

                  </DynamicCardForm>
                </Col>

              </Row>

            </Form>
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConfiguracionClientes);
